"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var lodash_1 = __importDefault(require("lodash"));
require("./three-sixty-rater-display-logic-modal.less");
var RaterDisplayLogicModalController = /** @class */ (function () {
    function RaterDisplayLogicModalController(
    // @ts-ignore
    $scope, 
    // @ts-ignore
    $filter, 
    // @ts-ignore
    displayLogicService, 
    // @ts-ignore
    metricsService) {
        this.$scope = $scope;
        this.$filter = $filter;
        this.displayLogicService = displayLogicService;
        this.metricsService = metricsService;
        $scope.$ctrl = this;
        this.translate = this.$filter('translate');
    }
    RaterDisplayLogicModalController.prototype.$onInit = function () {
        this.actionOptions = this.displayLogicService.getActionOptions();
        this.itemOptions = this.displayLogicService.getItemOptions();
        this.allDisplayLogics = this.displayLogicService.getDisplayLogics();
        if (this.haveDisplayLogics()) {
            this.previewFirstDisplayLogic();
        }
    };
    RaterDisplayLogicModalController.prototype.createNewDisplayLogic = function () {
        var newDisplayLogic = this.displayLogicService.getNewDisplayLogic();
        // add new display logic to the beginning of allDisplayLogics array
        this.allDisplayLogics.unshift(newDisplayLogic);
        this.previewFirstDisplayLogic();
    };
    RaterDisplayLogicModalController.prototype.getActionLabel = function () {
        var action = this.displayLogicToPreview.action;
        return action ? this.actionOptions[action] : this.translate('PR.SELECT_ACTION');
    };
    RaterDisplayLogicModalController.prototype.getItemLabel = function () {
        var item = this.displayLogicToPreview.item;
        return item ? this.itemOptions[item] : this.translate('PR.SELECT_ITEM');
    };
    RaterDisplayLogicModalController.prototype.setPreviewDisplayLogic = function (displayLogic) {
        this.displayLogicToPreview = displayLogic;
    };
    /**
     * Determine if we should show an error state (red text and caution icon).
     * We should show an error state if the display logic is not selected, and it is not valid
     */
    RaterDisplayLogicModalController.prototype.shouldShowErrorState = function (displayLogic) {
        return !this.isSelected(displayLogic)
            && !this.isValidDisplayLogic(displayLogic);
    };
    RaterDisplayLogicModalController.prototype.isSelected = function (displayLogic) {
        return displayLogic._id === this.displayLogicToPreview._id;
    };
    RaterDisplayLogicModalController.prototype.copyDisplayLogic = function (displayLogic) {
        // use angular.copy instead of _.cloneDeep here to avoid $$hashkey being copied
        var displayLogicCopy = angular_1.default.copy(displayLogic);
        displayLogicCopy.name = displayLogicCopy.name + ' ' + this.$filter('translate')('COPY');
        displayLogicCopy._id = this.displayLogicService.generateID();
        // add copy to the beginning
        this.allDisplayLogics.unshift(displayLogicCopy);
        this.previewFirstDisplayLogic();
    };
    RaterDisplayLogicModalController.prototype.deleteDisplayLogic = function (displayLogic) {
        this.metricsService.removeThreeSixtyRaterDisplayLogic(displayLogic._id);
        lodash_1.default.remove(this.allDisplayLogics, { _id: displayLogic._id });
        if (this.displayLogicToPreview._id === displayLogic._id) {
            // if deleting the selected display logic, select the first one after deleting
            this.previewFirstDisplayLogic();
        }
    };
    /**
     * check if there's any invalid display logic in the allDisplayLogics array
     */
    RaterDisplayLogicModalController.prototype.haveInvalidDisplayLogics = function () {
        var _this = this;
        return lodash_1.default.some(this.allDisplayLogics, function (displayLogic) {
            return !_this.isValidDisplayLogic(displayLogic);
        });
    };
    RaterDisplayLogicModalController.prototype.saveDisplayLogics = function () {
        this.metricsService.saveThreeSixtyRaterDisplayLogic(this.allDisplayLogics);
        // save displayLogic definition in report contextMeta
        this.displayLogicService.setDisplayLogics(this.allDisplayLogics);
    };
    RaterDisplayLogicModalController.prototype.haveDisplayLogics = function () {
        return this.allDisplayLogics.length > 0;
    };
    /**
     * the displayLogic is invalid if any property/element is empty
     */
    // @ts-ignore
    RaterDisplayLogicModalController.prototype.isValidDisplayLogic = function (displayLogic) {
        var _this = this;
        // check if action and item menu is selected
        if (displayLogic._id && (!displayLogic.item || !displayLogic.action)) {
            return false;
        }
        // if a single displayLogic object, check if every property is defined
        if (displayLogic.type === "displayLogic" /* DISPLAY_LOGIC */) {
            var elements = this.displayLogicService.getElementsForValidation();
            return lodash_1.default.every(elements, function (el) {
                // @ts-ignore
                // @ts-ignore
                return !lodash_1.default.isUndefined(displayLogic.displayLogic[el]);
            });
        }
        // if the displayLogic has children, check every child
        if (displayLogic.children && displayLogic.children.length) {
            return lodash_1.default.every(displayLogic.children, function (child) {
                return _this.isValidDisplayLogic(child);
            });
        }
        return true;
    };
    RaterDisplayLogicModalController.prototype.previewFirstDisplayLogic = function () {
        this.displayLogicToPreview = this.allDisplayLogics[0];
    };
    RaterDisplayLogicModalController.$inject = [
        '$scope',
        '$filter',
        'pr360RaterDisplayLogicService',
        'prMetricsService'
    ];
    return RaterDisplayLogicModalController;
}());
(function (angularModule) {
    angularModule.controller('prRaterDisplayLogicModalController', RaterDisplayLogicModalController);
})(angular_1.default.module('qualtrics.pr'));
